export default function getResource(label, vars = []) {
    const resources = {
        merchandiseSubtotalText: 'Subtotal',
        pointsUsed: 'Points Used (in this order)',
        discountsText: 'Discounts',
        free: 'FREE',
        tbdText: 'TBD',
        shippingAndHandlingText: 'Shipping',
        autoReplenishSavings: 'Auto-Replenish Savings',
        gstHstText: 'Estimated GST/HST',
        taxText: 'Estimated Tax',
        pickup: 'Pickup',
        bagFee: 'Pickup Bag Fee',
        bundleDescriptorLine: `Three 100-point rewards for ${vars[0]} points`,
        bundleOriginalPointsCost: `Original points cost: ${vars[0]} points`
    };

    return resources[label];
}
